import React from 'react';
import { NodeData } from '../../../pages/campaings/flows/types';

interface Props {
  data: NodeData;
}
const CloseBody: React.FC<Props> = ({ data }) => {
  if (!data.close) return <div>No se encontró información</div>;
  return (
    <>
      <p className="nowrap-lines-2 node-width-fit pe-2 mb-1">{data.close.message.es}</p>
      <h6 className="node-title2 my-0">Categoría de cierre</h6>
      <span className="badge bg-light-info text-dark mt-1 fs-9">{data.close.category}</span>
    </>
  );
};

export default React.memo(CloseBody);
